<template>
    <textarea 
        class="form-control" 
        :value="value"
        @input="updateValue($event.target.value)"
    />
</template>

<script>
export default {
    props: {
        value: [String, null]
    },
    mounted: function() {
        this.setHeight();
    },
    watch: {
        value: function(value) {
            setTimeout(this.setHeight, 0);
        }
    },
    methods: {
        updateValue: function(value) {
            this.setHeight();
            this.$emit('input', value);
        },
        setHeight: function() {
            $(this.$el).height(0).height(this.$el.scrollHeight - 8);
        }
    }
}
</script>